module.exports = __webpack_public_path__ + "static/media/option6-4row.380f13cf.png";